import { graphql } from "gatsby"
import React, { useContext } from "react"
import { PageContext } from "../../context/PageContext"
import useDatoMicrocopy from "../../hooks/useDatoMicrocopy"
import EmailLink from "../atoms/EmailLink"
import PhoneLink from "../atoms/PhoneLink"
import PostalAddress from "../atoms/PostalAddress"

const DatoContactLocation = (props: Queries.DatoContactLocationFragment) => {
  const { locale } = useContext(PageContext)
  const t = useDatoMicrocopy("contact", locale)

  return (
    <div>
      <h3>{props.title}</h3>
      <PostalAddress labelPrefixPo={t("abbrPoBox", "P.O.Box")} {...props} />

      <p>
        {props.phone && (
          <>
            <PhoneLink phone={props.phone} labelPrefix={t("abbrTelephone", "Tel.")} />
            <br />
          </>
        )}
        {props.email && <EmailLink email={props.email} labelPrefix={t("abbrEmail", "Email")} />}
      </p>
    </div>
  )
}

export default DatoContactLocation

export const quert = graphql`
  fragment DatoContactLocation on DatoCmsContactLocation {
    title
    description
    phone
    email
    faxNumber
    postOfficeBoxNumber
    streetAddress
    postalCode
    addressRegion
    addressLocality
    addressCountry
    availabilityDetails
    callRates
  }
`
